<div class="grid">
  <div class="col-12 md:ml-5 py-4">
    <div class="flex-auto flex-wrap justify-content-center">
      <form [formGroup]="orderInfoForm" (ngSubmit)="onSubmit()">
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 mb-3 align-content-center">
            <span class="label">{{ 'Order_Info.Healthcare_Professional' | translate }}</span>
          </div>
          <div class="sm:col-12 md:col-7">
            <div class="mb-3 flex">
              <div class="">
                <span class="label">{{ 'Order_Info.Name' | translate }}:</span>
              </div>
              <div class="ml-8">
                <span class="span-text">{{ orderData?.customerFirstName + ' ' + orderData?.customerLastName }}</span>
              </div>
            </div>
            <div class="flex">
              <div class="">
                <span class="label">{{ 'Order_Info.Institution' | translate }}:</span>
              </div>
              <div class="ml-6">
                <span class="span-text">{{ customerInstitution$ | async }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 align-content-center">
            <span class="label" [class.asterisk]="isRequired('phone') || isRequired('countryCode')">
              {{ 'Order_Info.Phone' | translate }}
            </span>
          </div>
          <div class="col:sm-12 md:col-7 flex">
            <div class="col-5 pl-0">
              <p-select
                id="countryCode"
                styleClass="w-full"
                [class.ng-invalid]="orderInfoForm.hasError('countryCodeRequired')"
                [class.ng-valid]="!orderInfoForm.hasError('countryCodeRequired')"
                formControlName="countryCode"
                [options]="(countries$ | async) ?? []"
                optionLabel="phoneNumberPrefixWithPlus"
                optionValue="phoneNumberPrefix"
                aria-describedby="country code"
                placeholder="{{ 'Order_Info.CountryCode' | translate }}" />
              @if (orderInfoForm.invalid && orderInfoForm.hasError('countryCodeRequired')) {
                <small class="text-danger">
                  {{ 'Order_Info.CountryCodeIsRequired' | translate }}
                </small>
              }
            </div>
            <div class="col-7 ml-2">
              <input
                pInputText
                id="phone"
                aria-describedby="phone-help"
                formControlName="phone"
                placeholder="00-0000-0000"
                class="w-full mb-1"
                [class.ng-invalid]="
                  orderInfoForm.hasError('phoneRequired') || orderInfoForm.hasError('phonePattern')
                " />
              @if (orderInfoForm.invalid && orderInfoForm.hasError('phoneRequired')) {
                <small class="text-danger block">
                  {{ 'Order_Info.PhoneIsRequired' | translate }}
                </small>
              }
              @if (orderInfoForm.invalid && orderInfoForm.hasError('phonePattern')) {
                <small class="text-danger block">
                  {{ 'Order_Info.Phone_Number_Only' | translate }}
                </small>
              }
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
